export {
    COLLECT_ENABLED,
    DEFAULT_COLLECT_URL,
    DEFAULT_HEALTH_FLUSH_DELAY_MAX_MS,
    DEFAULT_HEALTH_FLUSH_DELAY_MIN_MS,
    DEFAULT_HEALTH_FLUSH_THRESHOLD,
    DEFAULT_HEALTH_URL,
    MAX_EVENTS_PER_REQUEST,
    MAX_HEALTH_CHECKS_PER_REQUEST,
    METRIC_STATUSES,
    PROVIDER_ACTIONS,
    VISITOR_ID_STORAGE_KEY,
} from './constants';

export {createMetricCallEvent, isValidProviderAction} from './metric-call-event';

export {default as MetrikaCollector} from './metrika-collector';
export {collectHealth, normalizeHealthChecks, sendMetricHealth} from './health';
export {createHealthChecks, probeNetworkReachable, scheduleMetrikaHealthProbe} from './health-probe';

export {trackMetricCall} from './track-metric-call';

export {
    collectGoogleEvent,
    collectMailruReachGoal,
    collectMetric,
    collectRetail,
    collectYandexPurchase,
    collectYandexReachGoal,
    installYandexReachGoalConsoleLog,
    logYandexReachGoalConsole,
} from './collect';

import MetrikaCollector from './metrika-collector';

const collector = new MetrikaCollector();

export default collector;
